"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.twoFactorOptionsType = exports.identityType = exports.aliasType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var aliasType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  value: _propTypes.default.string,
  type: _propTypes.default.string,
  auth: _propTypes.default.bool,
  verified: _propTypes.default.bool
});

exports.aliasType = aliasType;

var twoFactorOptionsType = _propTypes.default.shape({
  aliases: _propTypes.default.arrayOf(aliasType),
  loginUuid: _propTypes.default.string,
  requested: _propTypes.default.bool
});

exports.twoFactorOptionsType = twoFactorOptionsType;

var identityType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  twoFactorEnabled: _propTypes.default.bool,
  aliases: _propTypes.default.arrayOf(aliasType),
  passwordExpired: _propTypes.default.bool,
  totpVerified: _propTypes.default.bool,
  sms2faVerified: _propTypes.default.bool,
  default2fa: _propTypes.default.string
});

exports.identityType = identityType;